import React from 'react';
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    ResponsiveContainer,
    Cell
} from 'recharts';
import getNumberWithCurrency from '../../helpers/getNumberWithCurrency';
import { __ } from '@wordpress/i18n';

const VerticalBarChart = ({
                              data,
                              title = 'Guadagni totali',
                              totalValue = null,
                              height = 270,
                              barColor = '#BDCCDE',
                              gridColor = '#E0E0E0',
                              showGrid = true,
                              barWidth = 40
                          }) => {
    // Calculate total if not provided
    const total = totalValue || data.reduce((sum, item) => sum + item.value, 0);

    // Custom Y-axis tick formatter
    const formatYAxisTick = (value) => {
        if (value === 0) return '0';
        if (value >= 1000) {
            return `${value / 1000}k`;
        }
        return value;
    };

    return (
        <>
            <div className="appDashboard__widgetTitle">
                <h2>{__('Guadagni totali', 'soundbetween')}</h2>
                <span>{getNumberWithCurrency(total)}</span>
            </div>
            <ResponsiveContainer width="100%" height={height}>
                <BarChart
                    data={data}
                    margin={{ top: 10, right: 10, left: 0, bottom: 10 }}
                >
                    {showGrid && (
                        <CartesianGrid
                            strokeDasharray="0"
                            stroke={gridColor}
                            vertical={false}
                            horizontalPoints={[0, 50, 100, 150]}
                        />
                    )}
                    <XAxis
                        dataKey="name"
                        axisLine={false}
                        tickLine={false}
                        tick={{ fontSize: 11, fill: '#666' }}
                        dy={10}
                    />
                    <YAxis
                        axisLine={false}
                        tickLine={false}
                        tick={{ fontSize: 11, fill: '#666' }}
                        tickFormatter={formatYAxisTick}
                        domain={[0, 'dataMax + 1000']}
                        ticks={[0, 2000, 4000, 6000]}
                    />
                    <Bar
                        dataKey="value"
                        radius={[4, 4, 0, 0]}
                        maxBarSize={barWidth}
                    >
                        {data.map((entry, index) => (
                            <Cell
                                key={`cell-${index}`}
                                fill={entry.color || barColor}
                            />
                        ))}
                    </Bar>
                </BarChart>
            </ResponsiveContainer>
        </>
    );
};

export default VerticalBarChart;